import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import Container from '../../../Core/Container';
import pco_ring_desktop from '../../../../images/pco-rings-desktop.svg';
import pco_ring_mobile from '../../../../images/pco-rings-mobile.svg';
import pco_ring_tablet from '../../../../images/pco-rings-tablet.svg';

export const StyledContainer = styled(Container)`
  &.pc-optimum-campaign-banner {
    background-size: cover;
    background-image: ${({ image }) => image && `url${image}`};
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 1200px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 0 auto;
    }
  }

  &.secondary-campaign-banner {
    min-width: 320px;
    min-height: 572px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-image: ${({ optimumStyle }) =>
      optimumStyle && pco_ring_mobile ? `url(${pco_ring_mobile})` : 'none'};
    background-repeat: no-repeat;
    background-position: center;

    // galaxy fold
    @media only screen and (min-width: 279px) {
      min-width: 280px;
    }

    @media only screen and (min-width: 360px) {
      min-width: 375px;
      min-height: 676px;
    }

    @media only screen and (min-width: 411px) {
      min-height: 720px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background-image: ${({ optimumStyle }) =>
        optimumStyle && pco_ring_tablet ? `url(${pco_ring_tablet})` : 'none'};
      min-height: 360px;
      margin: 0 auto;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      background-image: ${({ optimumStyle }) =>
        optimumStyle && pco_ring_desktop ? `url(${pco_ring_desktop})` : 'none'};
      max-width: 1200px;
      min-height: 300px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      min-height: 375px;
    }
  }

  &.optimum-pink {
    background-color: ${themeGet('colors.pink')};
  }

  &.velvet {
    background-color: ${themeGet('colors.velvet')};
  }

  &.pc-red {
    background-color: ${themeGet('colors.pc-red', '#E1251B')};
  }
`;

export const Wrapper = styled.div`
  margin: -15px;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  ${StyledContainer}.pc-optimum-campaign-banner & {
    max-width: 1200px;
    width: calc(100% - 30px);
    margin: 30px -15px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: calc(100% - 40px);
      margin: 0 -15px;
    }
  }

  ${StyledContainer}.secondary-campaign-banner & {
    margin: auto;
    align-items: center;
    justify-content: center;
  }
`;

export const Img = styled(Image)`
  width: 100%;
  max-width: 215px;
  margin: 15px auto;
  object-fit: contain;
  object-position: center;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  @media only screen and (min-width: 444px) {
    margin: 15px;
    min-width: 215px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-width: 300px;
    min-width: auto;
  }

  ${StyledContainer}.pc-optimum-campaign-banner & {
    max-width: 350px;
    margin: 15px auto;
  }

  ${StyledContainer}.secondary-campaign-banner & {
    max-width: unset;
    width: 270px;
    height: 270px;
    margin: 70px 16px 0px;

    // galaxy fold
    @media only screen and (min-width: 279px) {
      margin: 50px auto 0px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      margin: 80px 52px 0px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 45px 51px 45px 0px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin: auto 52px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 52px;
    }
  }
`;

export const Content = styled.div`
  max-width: 820px;
  margin: 15px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
  }

  ${StyledContainer}.pc-optimum-campaign-banner & {
    margin: 15px 15px 45px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 45px 15px;
    }
  }

  ${StyledContainer}.secondary-campaign-banner & {
    display: flex;
    margin: 24px;
    min-height: 240px;

    // galaxy fold
    @media only screen and (min-width: 279px) {
      min-height: 190px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      margin: 32px;
      min-height: 240px;
    }

    @media only screen and (min-width: 413px) {
      margin: 42px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 340px;
      margin-left: 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 500px;
      margin: auto;
      margin-left: 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 740px;
      min-height: 190px;
      margin: 92px 110px 92px 0 px;
    }
  }
`;

export const Title = styled.h2`
  margin-bottom: 30px;

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin-bottom: 50px;
  }

  ${StyledContainer}.pc-optimum-campaign-banner & {
    margin: 0 0 1.5rem;
  }

  ${StyledContainer}.pc-optimum-campaign-banner & {
    margin: 0 0 1.5rem;
  }

  ${StyledContainer}.secondary-campaign-banner & {
    margin: auto;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin: 2rem auto;
    }
  }

  ${StyledContainer}.velvet &,
  ${StyledContainer}.pc-red & {
    color: ${themeGet('colors.white')};
  }
`;

export const BodyCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  p {
    &:last-of-type {
      margin-bottom: 30px;
    }
  }

  ${StyledContainer}.velvet &,
  ${StyledContainer}.pc-red & {
    p {
      color: ${themeGet('colors.white')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
    margin: -0.25rem;
    p {
      font-size: 24px;
      font-weight: ${themeGet('fontWeights.normal')};
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      margin: 0.25rem;

      &:last-of-type {
        margin: 0.25rem;
      }

      ${StyledContainer}.pc-optimum-campaign-banner & {
        font-size: 1.25rem;

        &:last-of-type {
          margin-bottom: 1.5rem;
        }
      }
    }

    a {
      margin: 0.25rem;
      font-size: 18px;

      ${StyledContainer}.pc-optimum-campaign-banner & {
        width: max-content;
      }
    }
  }
`;
